import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loadingStore', () => {
  let doneTimeout = null;
  const loading = ref(false);
  const done = ref(false);

  function start() {
    clearDoneTimeout();

    done.value = false;
    loading.value = true;
  }

  function complete() {
    clearDoneTimeout();

    done.value = true;
    loading.value = false;

    doneTimeout = setTimeout(() => {
      done.value = false;
    }, 500);
  }

  function clearDoneTimeout() {
    if (doneTimeout) {
      clearTimeout(doneTimeout);
    }
  }

  return {
    loading,
    done,
    start,
    complete,
  };
});
